import {
    getIsStackerNativeObject,
    getIsStackerSharedObject,
    getIsStackerSharedObjectCopy,
} from 'features/admin/stackerNativeObjectUtils'

export function useDeleteTableState(object?: ObjectDto) {
    const isNativeTable = getIsStackerNativeObject(object)
    const isSharedTable = getIsStackerSharedObject(object)
    const isSharedTableCopy = getIsStackerSharedObjectCopy(object)
    const isSharedTableOriginal = isSharedTable && !isSharedTableCopy
    const isProtectedByGrant = object?.connection_options?.is_protected_by_grant

    const canDelete = !isSharedTableOriginal && !object?.system_object_type

    let title = ''
    let description = ''
    if (isSharedTableCopy) {
        title = 'Remove shared table'
        description = 'Remove shared table from this app.'
    } else if (isProtectedByGrant) {
        title = 'Delete table'
        description =
            'This table is required in user table group. Please first remove associated table groups if you wish to delete.'
    } else if (isSharedTableOriginal) {
        title = 'Delete table'
        description = 'This table is shared with the Workspace. Stop sharing it to delete.'
    } else if (!!object?.system_object_type) {
        title = 'Delete table'
        description = 'This table cannot be deleted.'
    } else if (isNativeTable) {
        title = 'Delete table'
        description = 'Remove this table and all associated data.'
    } else {
        title = 'Delete synced table'
        description = 'Delete synced table and all associated data.'
    }

    return {
        title,
        description,
        canDelete,
    }
}
